<template>
  <div>登录中，请稍后。。。<el-button type="text" @click="logout()">重新登录</el-button></div>
</template>

<script>
import idaas from "@/apis/idaas";
export default {
    async created(){
        let state = this.$route.query.state;
       let resp =  await idaas.getCasUserInfo()
       console.log(resp)
       localStorage.removeItem('IDAAS_BEARER_TOKEN')
       idaas.loginCas(state,{data:resp.data}).then((res) => {
            window.open(res.data.url,"_self")
          }).catch((res) => {
            console.log(res)
            if (res.data.code==10013){
              this.$msgbox.confirm('登录页面已过期，您可以继续留在该页面，或者重新进入', '系统提示', {
                  confirmButtonText: '重新进入',
                  cancelButtonText: '取消',
                  type: 'warning'
                }
              ).then(() => {
                window.history.back(-1) 
              }).catch(() => {});
            }
            this.loading = false;
          });
    } ,
    methods:{
      logout(){
        window.open("/idaas/app/logout")
      }
    } 
}
</script>

<style>

</style>